import React, { FC } from 'react'
import cx from 'classnames'

import ActionButton, { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type DeleteModalProps = {
  className?: string
  title: string
  text?: string
  buttons?: ActionButtonProps[]
}

const DeleteModal: FC<DeleteModalProps> = (props) => {
  const { className, title, buttons, text } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.Header>
        <SC.Title>{title}</SC.Title>
      </SC.Header>
      <SC.Content>
        {text && <SC.Text>{text}</SC.Text>}
        <SC.ButtonContainer>
          {buttons && buttons.map((button, index) => <ActionButton key={index} {...button} />)}
        </SC.ButtonContainer>
      </SC.Content>
    </SC.Container>
  )
}

export default DeleteModal
